var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.middleList.length>0)?_c('div',{staticClass:"sub-banner",style:({
          backgroundImage: ("url(" + (_vm.middleList[0].imageUrl) + ")"),
          width:_vm.width,
          height:_vm.height
        }),on:{"click":function($event){return _vm.goto(_vm.middleList[0].route)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }